import React from 'react'
import Layout from '../../common/Layout'
import AdviserProfileEditorContainer from '../../features/AdviserProfileEditor/AdviserProfileEditorContainer/AdviserProfileEditorContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/adviser/:id/profile/edit',
  async action ({ params }) {
    const adviserId = parseInt(params.id)
    return {
      title: 'Adviser',
      component: <Layout containerWell>
        <AdviserProfileEditorContainer adviserId={adviserId} />
      </Layout>
    }
  }
}
